import { getUserContext } from "@bagel-web/common";
import { FeatureFlags, useFeatureFlags } from "./featureFlags";

export const OrganizationPermissions = Object.freeze({
  ManageUsersTable: "widgets:users-table:manage",
  ManageProjects: "dashboard:projects:manage",
  ViewServiceUsage: "dashboard:services:usage:view",
  ManageServices: "dashboard:services:manage",
});

export const useRBAC = () => {
  const { permissions } = getUserContext();
  const { isFeatureFlagEnabled } = useFeatureFlags();

  return {
    hasPermission: (
      permission: (typeof OrganizationPermissions)[keyof typeof OrganizationPermissions]
    ) =>
      permissions.includes(permission) ||
      !isFeatureFlagEnabled(FeatureFlags.DASHBOARD_ORG_SCOPED_RBAC),
  };
};
